<template>
  <div class="inputs-row">
    <slot />
    <span class="row-title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'CardInputsRow',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
.inputs-row
  display: flex
  justify-content: center
  align-items: center
  margin: 0 0 8px
  .row-title
    padding: 0 0 0 8px
    font-size: 14px
    line-height: 120%
    color: #BCC4D2
    min-width: 102px
    text-align: left
</style>